import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasWarnings
    ? _c(
        "div",
        { staticClass: "price-warnings" },
        [
          _c(
            VTooltip,
            {
              attrs: {
                bottom: "",
                "max-width": "400",
                "content-class": "price-warnings-tooltip",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          VIcon,
                          _vm._g(
                            _vm._b(
                              {
                                staticClass: "price-warnings-icon",
                                attrs: {
                                  size: "1.5rem",
                                  "aria-label": "Price explanation warnings",
                                },
                              },
                              "v-icon",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [_vm._v("\n        mdi-help-circle\n      ")]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                2033297841
              ),
            },
            [
              _vm._v(" "),
              _c("div", { staticClass: "price-warnings-content" }, [
                _c("p", { staticClass: "price-warnings-prefix mb-2" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("gridView.priceWarnings.prefix")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "price-warnings-list" },
                  _vm._l(_vm.structuredWarnings, function (warning, key) {
                    return _c(
                      "li",
                      { key: key, staticClass: "price-warnings-item" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getWarningMessage(key, warning)) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }